import { cn } from "@omni/utils/styles";

import { useImageGalleryContext } from "@/components/ImageGallery/context/imageGallery.context";

type Props = {
    className?: string;
};

export const NextButton = ({ className }: Props) => {
    const { images, activeIndex, next } = useImageGalleryContext();

    if (images.length <= 1) return null;

    const disabled = activeIndex >= images.length - 1;

    return (
        <button
            type={"button"}
            className={cn(className, "tw:border-0 tw:bg-transparent")}
            disabled={disabled}
            onClick={next}
        >
            <i
                className={cn("tw:text-3xl las la-angle-right", {
                    "tw:text-primary": !disabled
                })}
            />
        </button>
    );
};
